import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.white,
  textColorDark: colors.ash,
  textColorLight: colors.white,
  alignTextLeft: true
};
export default fiftyFiftyCard;